// extracted by mini-css-extract-plugin
export var filterIncDec = "_e1-0";
export var leftBorder = "_e1-1";
export var rightBorder = "_e1-2";
export var stringInput = "_e1-3";